var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { ModalFormFormat } from "../../UI/FormFormat/FormFormat";
import useUniqueId from "../../Hooks/useUniqueId";
import SearchField from "../../Form/SearchField";
import { PersonSearch } from "../Person/PersonSearch";
import PersonMergeService from "../../../Services/PersonMerge.service";
import { AlertSuccess } from "../../UI/StandardAlerts/StandardAlerts";
import LinkToPerson from "../Person/LinkToPerson/LinkToPerson";
import PersonTypeDomainService from "../../../Domain/PersonType/PersonType.service";
const ProspectMergingModal = (_a) => {
    var { sourcePerson } = _a, modalProps = __rest(_a, ["sourcePerson"]);
    const [target, setTarget] = useState("");
    const makeId = useUniqueId()[1];
    return (_jsxs(ModalFormFormat, Object.assign({}, modalProps, { keepModalOpenAfterSuccess: _jsx(AlertSuccess, { message: _jsxs("span", { children: ["Successfully merged ", sourcePerson === null || sourcePerson === void 0 ? void 0 : sourcePerson.fullName, " with", target && (_jsxs(LinkToPerson, { className: "alert-link ml-1 align-baseline", 
                        // @ts-expect-error - TS2339 - Property 'affiliationId' does not exist on type 'string'.
                        affiliationId: target.affiliationId, children: [" ", target.fullName] }))] }) }), saveButtonContents: "Merge", modalTitle: "Merge Person Records", handleSubmit: ({ person }) => {
            return PersonMergeService.mergePeople(sourcePerson.personId, person.personId).then(() => {
                // @ts-expect-error - TS2345 - Argument of type 'PersonLite' is not assignable to parameter of type 'SetStateAction<string>'.
                setTarget(person);
            });
        }, children: [_jsx("p", { children: "This process is for the reconciliation of duplicate person records." }), _jsx("p", { children: "Data will be copied to the target person, and this person record will be deleted." }), _jsx("p", { children: "This cannot be undone." }), _jsx("div", { className: "form-group", children: _jsx(SearchField, { label: "Search for person record to merge with", name: "person", required: true, as: (provided) => (_jsx(PersonSearch, Object.assign({}, provided, { personTypeInternalNames: [
                            PersonTypeDomainService.StudentPersonTypeInternalName,
                            PersonTypeDomainService.ApplicantPersonTypeInternalName,
                            PersonTypeDomainService.ProspectPersonTypeInternalName,
                        ], excludePersonIds: [sourcePerson.personId] }))) }) })] })));
};
export default ProspectMergingModal;
